// Format an edge value (0..1, where 0.058 = 5.8%) as the operator-facing
// string. Spec § 21.3: "Edge values siempre con signo explícito".
//   formatEdge(0.058)  → "+5.8%"
//   formatEdge(-0.012) → "-1.2%"
//   formatEdge(null)   → "—"
export function formatEdge(edgePct: number | null | undefined): string {
  if (edgePct === null || edgePct === undefined) return '—';
  const pct = edgePct * 100;
  const sign = pct >= 0 ? '+' : '';
  return `${sign}${pct.toFixed(1)}%`;
}

// Tailwind class for an edge value's color. Caller composes into className.
export function edgeColorClass(edgePct: number | null | undefined): string {
  if (edgePct === null || edgePct === undefined) return 'text-muted-foreground';
  if (edgePct > 0) return 'text-positive';
  if (edgePct < 0) return 'text-negative';
  return 'text-muted-foreground';
}
